<template>
  <span>
    <b-button class="btn btn-primary btn-sm" :disabled="disabled" size="sm" @click="show()" title="Substitution d'article">
      <i class="fas fa-exchange-alt"></i>
    </b-button>

    <b-modal v-model="afficherModale" size="xl" title="Substitution d'article"
      ok-title="Choisir" :ok-disabled="!article"
      cancel-title="Annuler"
      no-close-on-backdrop
      @show="init()"
      @ok="substituerArticle()">
      <template slot="default">
        <RechercheArticles :ajoutActif="true" :fournisseurId="fournisseurId" @change-ingredient="changeIngredient($event)" @change-state="changeEtatRecherche($event)" />
        <h5 class="push-top-1rem" :key="stateSearch" v-if="stateSearch">
          {{stateSearch}}
        </h5>
        <ArticlesParProduit v-if="ingredient && ingredient.parProduit" :articles="ingredient.parProduit" :favoris="ingredient.favoris" @selection-article="setArticle($event)" @validation-article="substituerArticle()" />
      </template>
    </b-modal>
  </span>
</template>

<script>
import { mapGetters } from "vuex"
import { connecteData } from '@/mixins/connecteData'
import { fournisseurs } from '@/mixins/fournisseurs'
import RechercheArticles from './RechercheArticles.vue'
import ArticlesParProduit from '../Stock/ArticlesParProduit.vue'

export default {
  name: "RechercheAjoutProduit",
  props: [ 'fournisseurId', 'disabled' ],
  mixins: [ fournisseurs, connecteData ],
  components: {
    RechercheArticles,
    ArticlesParProduit
  },
  data() {
    return {
      optionsProduits: [],
      afficherModale: false,
      referenceArticle: '',
      afficherRechercheParFamille: false,
      afficherResultat: false,
      ajouterProduit: false,
      familleId: null,
      produitId: null,
      produit: null,
      article: null,
      fournisseur: this.$store.state.fournisseurs.fournisseursCourants.find(el => el.id === this.fournisseurId),
      stateSearch: '',
      ingredient: null,
      creerArticle: false
    }
  },
  computed: {
    ...mapGetters("definitions", ["ingredients"]),
    ...mapGetters("definitions", ["familles"]),
    famillesFournisseur() {
      let etab = this.utilisateurCourant.etablissements.find(x => x.eId === this.etabCourantId)
      let ff = etab.choixFournisseurs.filter(x => x.foId === this.fournisseurId)
      return this.familles.filter(x => ff.map(y => y.fId).includes(x.id) && x.actif)
    }
  },
  methods: {
    init() {
      this.ingredient = {}
      this.referenceArticle = ''
      this.afficherRechercheParFamille = false
      this.afficherResultat = false
      this.ajouterProduit = false
      this.familleId = null
      this.produit = null
      this.article = null
      this.stateSearch = ""
    },
    show() {
      this.afficherModale = true
    },
    hide() {
      this.afficherModale = false
    },
    changeEtatRecherche(etat) {
      this.stateSearch = etat
    },
    changeIngredient(ingredient) {
      this.creerArticle = false
      this.ajouterProduit = false
      this.ingredient = ingredient
      this.familleId = null
      this.produitId = null
      this.produit = null
      this.article = null
    },
    setArticle(elt) {
      this.article = elt
      this.$set(this.article, 'designationFournisseur', elt.designationFournisseur || elt.designation)
      this.$set(this.article, 'valeurUnitaire', elt.valeurUnitaire || elt.prixUnitaire)

      this.ingredient.tarifId = this.article.tarifId
      this.ingredient.uc = this.article.uc
    },
    substituerArticle() {
      if (!this.article)
        return
      
      this.$emit('substituer-article', { article: this.article })
      this.hide()
    },
    annuler() {
      this.hide()
    }
  }
}
</script>
